import React from 'react';
import PropTypes from 'prop-types';
import { domToReact } from 'html-react-parser';

import ArticleMultipleChoiceCTA from '../../../../../components/Molecules/ArticleMultipleChoiceCTA';
import { testAttributes, tags, wpQlmultictaClass } from './Constants';

const extractSectionElements = (sectionChildren) => 
{
    const data = {
        title: '', 
        buttonLabel: '' 
    }

    const title = sectionChildren?.filter(item => item.name === 'h3');
    const button = sectionChildren?.filter(item => item.name === 'a').map(item => item.children[0]);

    if (title && title.length > 0) 
    {
        data.title = title[0]?.children[0]?.data;
    } 

    if (button && button.length > 0) 
    {
        data.buttonLabel = domToReact([button[0]]) 
    }

    return data;
}

const toMultiCTA = (pageData) => 
{
    const Wrapper = ({ name = '', type = '', attribs = { href: '' }, children = null }) =>
    {
        if ( type !== 'tag' ) return null;
        if (!name || name !== 'aside') return null;  
        if (!attribs?.class || !attribs?.class.includes(wpQlmultictaClass)) return null;

        const sectionChildren = children?.filter((child) => child.type === 'tag' && tags.includes(child.name));
        const props = extractSectionElements(sectionChildren);
        props.variant = 'new';

        return <div data-testid={testAttributes.MULTI_CHOICE_CTA_CONTAINER}>
            <ArticleMultipleChoiceCTA {...props} {...pageData} />
        </div>;
    }

    Wrapper.propTypes = {
        name: PropTypes.oneOf(['h3', 'a']),
        type: PropTypes.oneOf(['tag']),
        attribs: PropTypes.shape({
            class: PropTypes.string
        }),
        children: PropTypes.node,
    }

    return Wrapper;
}

export default toMultiCTA;
